'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAccountByAdmin = exports.searchAccountsForText = exports.detachFeis = exports.attachFeis = exports.getMyCompetitorsForFeis = exports.getPaymentsForAccount = exports.getFeiseannaForAccount = exports.getBalancesForAccount = exports.getMyFeiseanna = exports.getPerson = exports.getAccountForPerson = exports.deleteDependents = exports.addDependent = exports.setSchoolForDependent = exports.updateDependent = exports.getDependents = exports.getMyAccount = exports.getAccount = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _middleware = require('../../middleware');

var _immutable = require('immutable');

var _events = require('../events');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var getAccount = exports.getAccount = function getAccount(acct_id) {
  return function (dispatch, getState) {
    var person = getState().getIn(['persons', 'one', acct_id]);

    // prefer the cached version if email is present. If not, then fetch account information.
    if (person && person.get('email')) return;

    dispatch(_defineProperty({
      pid: acct_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/' + acct_id
      },
      types: ['GET_PERSON_START', 'GET_PERSON', 'GET_PERSON_ERROR']
    }));
  };
};

var getMyAccount = exports.getMyAccount = function getMyAccount() {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/me'
      },
      types: ['GET_MY_ACCOUNT_START', 'GET_MY_ACCOUNT', 'GET_MY_ACCOUNT_ERROR']
    }));
  };
};

var getDependents = exports.getDependents = function getDependents(acct_id) {
  return function (dispatch, getState) {
    var dependents = getState().getIn(['accounts', acct_id, 'dependents']);

    // prefer the cached version
    if (dependents) return;

    dispatch(_defineProperty({
      acct_id: acct_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/' + acct_id + '/dependents'
      },
      types: ['UPDATE_DEPENDENTS_START', 'UPDATE_DEPENDENTS', 'UPDATE_DEPENDENTS_ERROR']
    }));
  };
};

var updateDependent = exports.updateDependent = function updateDependent(acct_id, person) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      acct_id: acct_id,
      person: person

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/' + person.id,
        method: 'PUT',
        data: person
      },
      types: ['UPDATE_DEPENDENT_START', 'UPDATE_DEPENDENT', 'UPDATE_DEPENDENT_ERROR']
    }))

    /**
     * Clean eligible events for an updated dependent,
     * because she might no longer qualify for them
     */

    .then(function () {
      return dispatch((0, _events.deleteEligibleEventsForPerson)(person.id));
    });
  };
};

var setSchoolForDependent = exports.setSchoolForDependent = function setSchoolForDependent(acct_id, person, school_id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      acct_id: acct_id,
      person: person,
      school_id: school_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/persons/' + person.id + '/school',
        method: 'PUT',
        data: { school_id: school_id }
      },
      types: ['UPDATE_DEPENDENT_START', 'UPDATE_DEPENDENT', 'UPDATE_DEPENDENT_ERROR']
    }));
  };
};

var addDependent = exports.addDependent = function addDependent(acct_id, dependent) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      acct_id: acct_id,
      dependent: dependent

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/' + acct_id + '/dependents',
        method: 'POST',
        data: dependent
      },
      types: ['ADD_DEPENDENT_START', 'ADD_DEPENDENT', 'ADD_DEPENDENT_ERROR']
    }));
  };
};

var deleteDependents = exports.deleteDependents = function deleteDependents(acct_id) {
  return {
    acct_id: acct_id,
    type: 'DELETE_DEPENDENTS'
  };
};
var getAccountForPerson = exports.getAccountForPerson = function getAccountForPerson(pid) {
  return function (dispatch, getState) {

    var accountId = getState().getIn(['persons', 'one', pid, 'acct_id']);

    // prefer the cached version
    if (accountId) return Promise.resolve({ account: (0, _immutable.Map)({ acct_id: accountId }) });

    return dispatch(_defineProperty({
      pid: pid
    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/for-person/' + pid
      },
      types: ['UPDATE_PERSON_START', 'UPDATE_PERSON', 'UPDATE_PERSON_ERROR']
    })).then(function (resp) {
      return dispatch({ pid: pid, account: (0, _immutable.Map)({ acct_id: resp.payload.id }), type: 'UPDATE_PERSON' });
    });
  };
};

var getPerson = exports.getPerson = function getPerson(person_id) {
  return function (dispatch, getState) {
    var person = getState().getIn(['persons', 'one', person_id]);

    // prefer the cached version
    if (person) return;

    dispatch(_defineProperty({
      pid: person_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/persons/' + person_id
      },
      types: ['GET_PERSON_START', 'GET_PERSON', 'GET_PERSON_ERROR']
    }));
  };
};

var getMyFeiseanna = exports.getMyFeiseanna = function getMyFeiseanna(acct_id) {
  return function (dispatch, getState) {
    var feis = (0, _paths.getMyFeiseanna)(getState(), acct_id);

    // prefer the cached version
    if (feis.size > 0) return Promise.resolve(feis.toJS());

    return dispatch(_defineProperty({
      acct_id: acct_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/mine'
      },
      types: ['GET_MY_FEISEANNA_START', 'GET_MY_FEISEANNA', 'GET_MY_FEISEANNA_ERROR']
    }));
  };
};

var getBalancesForAccount = exports.getBalancesForAccount = function getBalancesForAccount(acct_id) {
  return function (dispatch, getState) {
    var feis = getState().getIn(['accounts', acct_id, 'balances']);

    // prefer the cached version
    if (feis) return;

    return dispatch(_defineProperty({
      acct_id: acct_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/' + acct_id + '/payments-due'
      },
      types: ['GET_BALANCES_FOR_ACCOUNT_START', 'GET_BALANCES_FOR_ACCOUNT', 'GET_BALANCES_FOR_ACCOUNT_ERROR']
    }));
  };
};

var getFeiseannaForAccount = exports.getFeiseannaForAccount = function getFeiseannaForAccount(acct_id) {
  return function (dispatch, getState) {
    var feiseanna = getState().getIn(['accounts', acct_id, 'feiseanna']);

    // prefer the cached version
    if (feiseanna) return;

    return dispatch(_defineProperty({
      acct_id: acct_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna'
      },
      types: ['GET_FEISEANNA_FOR_ACCOUNT_START', 'GET_FEISEANNA_FOR_ACCOUNT', 'GET_FEISEANNA_FOR_ACCOUNT_ERROR']
    }));
  };
};

var getPaymentsForAccount = exports.getPaymentsForAccount = function getPaymentsForAccount(acct_id) {
  return function (dispatch, getState) {
    var payments = getState().getIn(['accounts', acct_id, 'payments']);

    // prefer the cached version
    if (payments) return;

    return dispatch(_defineProperty({
      acct_id: acct_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/' + acct_id + '/payments'
      },
      types: ['GET_PAYMENTS_FOR_ACCOUNT_START', 'GET_PAYMENTS_FOR_ACCOUNT', 'GET_PAYMENTS_FOR_ACCOUNT_ERROR']
    }));
  };
};

var getMyCompetitorsForFeis = exports.getMyCompetitorsForFeis = function getMyCompetitorsForFeis(feis_id, acct_id) {
  return function (dispatch, getState) {
    var competitors = getState().getIn(['feiseanna', 'persons', feis_id, 'all']);
    var params = { limit: 0 };

    // prefer the cached version
    if (competitors) return;

    return dispatch(_defineProperty({
      feis_id: feis_id,
      acct_id: acct_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/competitors',
        params: _extends({}, params, {
          mine: true
        })
      },
      types: ['GET_MY_COMPETITORS_FOR_FEIS_START', 'GET_MY_COMPETITORS_FOR_FEIS', 'GET_MY_COMPETITORS_FOR_FEIS_ERROR']
    }));
  };
};

var attachFeis = exports.attachFeis = function attachFeis(acct_id, feis_id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      acct_id: acct_id,
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/' + acct_id + '/feiseanna',
        method: 'POST',
        data: { id: feis_id }
      },
      types: ['ATTACH_FEIS_START', 'ATTACH_FEIS', 'ATTACH_FEIS_ERROR']
    }));
  };
};

var detachFeis = exports.detachFeis = function detachFeis(acct_id, feis_id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      acct_id: acct_id,
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/' + acct_id + '/feiseanna/' + feis_id,
        method: 'DELETE'
      },
      types: ['DETACH_FEIS_START', 'DETACH_FEIS', 'DETACH_FEIS_ERROR']
    }));
  };
};

var searchAccountsForText = exports.searchAccountsForText = function searchAccountsForText(searchText, feisId) {
  return function (dispatch, getState) {

    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/search/admin?text=' + searchText + (feisId ? '&feis_id=' + feisId : '')
      },
      types: ['GET_ACCOUNTS_SEARCH_TEXT_START', 'GET_ACCOUNTS_SEARCH_TEXT', 'GET_ACCOUNTS_SEARCH_TEXT_ERROR']
    }));
  };
};

var updateAccountByAdmin = exports.updateAccountByAdmin = function updateAccountByAdmin(props) {
  return function (dispatch, getState) {
    var aid = props.id;

    return dispatch(_defineProperty({
      aid: aid
    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/accounts/' + aid + '/admin',
        method: 'PUT',
        data: props
      },
      types: ['UPDATE_ACCOUNT_START', 'UPDATE_ACCOUNT', 'UPDATE_ACCOUNT_ERROR']
    })).then(function (res) {
      if (res.type === 'UPDATE_ACCOUNT_ERROR') {
        return Promise.reject(res);
      }
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/accounts/index.js
// module id = 25
// module chunks = 0